export default __webpack_public_path__ + "static/media/brilliant_beach.ec7369b8.svg";